export default {
    parts: [],
    baseStyle: (props) => ({
        wrapper: {
            marginBottom: 12
        },
        collapsibleWrapper: {
            marginBottom: 4,
            borderBottom: "1px solid",
            borderColor: "black"
        },
        collapsibleTitle: {
            fontSize: 'md',
            fontWeight: 'normal',
            mb: 2,
            pb: 2,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        h1: {
            fontSize: {base: 'xl', lg: '2xl'},
            fontWeight: 'bold',
            marginBottom: 5
        },
        h3: {
            fontSize: 'md',
            fontWeight: 'bold',
            marginBottom: 5
        }
    })
}
